import { Provider, Type } from '@angular/core';
import { ENTITY_TAG_REPOSITORY, EntityTagRepository } from './data/entity-tag-repository';
import { TagEntityQuery } from './data/tag-entity.query';
import { TAG_REPOSITORY, TagRepository } from './data/tag-repository';

export function provideTagging(
  tagRepository: Type<TagRepository>,
  entityTagRepository?: Type<EntityTagRepository>,
): Provider[] {
  return [
    {
      provide: TAG_REPOSITORY,
      useExisting: tagRepository,
    },
    {
      provide: ENTITY_TAG_REPOSITORY,
      useExisting: entityTagRepository ?? tagRepository,
    },
    TagEntityQuery,
  ];
}
